import React, { useEffect, useState } from "react";
import axios from "axios";
import { formatInTimeZone } from "date-fns-tz";

const FormularioNuevo = ({ onSubmit, usuario }) => {
  const [residentes, setResidentes] = useState([]);

  const getFechaCDMX = () => {
    const now = new Date();
    return formatInTimeZone(now, "America/Mexico_City", "yyyy-MM-dd'T'HH:mm");
  };

  const [formulario, setFormulario] = useState({
    fecha: getFechaCDMX(),
    nombre: "",
    residente: "",
    turno: "",
    tension_arterial: "",
    saturacion_de_oxigeno: "",
    frecuencia_cardiaca: "",
    frecuencia_respiratoria: "",
    temperatura: "",
    indice_glucemico: "",
    llenado_capilar: "",
    bano: "",
    cambio_ropa: "",
    curaciones: "",
    micciones: {
     "1": [], "2": [], "3": [], "4": [], "5": [], "6": [], "7": [], "no_micciono": []
    },
    medicamentos_extras: "",
    micciones_observaciones: "",
    evacuaciones_observaciones: "",
    desayuno: "",
    colacion_manana: "",
    comida: "",
    colacion_tarde: "",
    cena: "",
    observaciones: "",
    paciente_salio: false,
    evacuaciones: {
      "1": [], "2": [], "3": [], "4": [], "5": [], "6": [], "7": [], "no_evacuo": []
    }
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormulario({ ...formulario, [name]: type === "checkbox" ? checked : value });
  };

  const toggleMiccion = (vez, tipo) => {
    setFormulario(prev => {
      const actuales = prev.micciones[vez] || [];
      const updated = actuales.includes(tipo)
        ? actuales.filter(t => t !== tipo)
        : [...actuales, tipo];
      return {
        ...prev,
        micciones: { ...prev.micciones, [vez]: updated }
      };
    });
  };

  const toggleEvacuacion = (vez, tipo) => {
    setFormulario(prev => {
      const actuales = prev.evacuaciones[vez] || [];
      const updated = actuales.includes(tipo)
        ? actuales.filter(t => t !== tipo)
        : [...actuales, tipo];
      return {
        ...prev,
        evacuaciones: { ...prev.evacuaciones, [vez]: updated }
      };
    });
  };

  const fetchResidentes = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/residentes`, {
        headers: { Authorization: token }
      });
      setResidentes(res.data);
    } catch (error) {
      console.error("Error cargando residentes", error);
    }
  };

  useEffect(() => {
    fetchResidentes();
  }, []);

  useEffect(() => {
    if (usuario) {
      console.log("📌 Asignando usuario al formulario:", usuario);
      setFormulario((prev) => ({ ...prev, nombre: usuario }));
    }
  }, [usuario]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    onSubmit(formulario);
  };

  return (
    <form onSubmit={handleSubmit} className="card shadow p-4">
      <h3 className="text-center text-primary mb-4">Hoja de control diario</h3>

      <div className="mb-3">
        <label className="form-label">Fecha *</label>
        <input type="datetime-local" className="form-control" value={formulario.fecha} disabled />
      </div>

      <div className="mb-3">
        <label className="form-label">Residente *</label>
        <select className="form-select" name="residente" value={formulario.residente} onChange={handleChange} required>
          <option value="">Seleccione residente</option>
          {residentes.map((r, i) => (
            <option key={i} value={r.nombre}>{r.nombre}</option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label className="form-label">Nombre del cuidador</label>
          <input
            type="text"
            className="form-control"
            name="nombre"
            value={formulario.nombre || ""}
            readOnly
            disabled
          />
      </div>

      <div className="form-check mb-3">
        <input className="form-check-input" type="checkbox" name="paciente_salio" checked={formulario.paciente_salio} onChange={handleChange} />
        <label className="form-check-label">El paciente salió</label>
      </div>

      {!formulario.paciente_salio && (
        <>
          <div className="mb-3">
            <label className="form-label">Turno *</label>
            <select name="turno" className="form-select" value={formulario.turno} onChange={handleChange} required>
              <option value="">Seleccione turno</option>
              <option value="matutino">Matutino</option>
              <option value="vespertino">Vespertino</option>
              <option value="nocturno">Nocturno</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Tensión arterial</label>
            <input type="text" name="tension_arterial" className="form-control" placeholder="Ej. 120/80" pattern="^\d{2,3}/\d{2,3}$" value={formulario.tension_arterial} onChange={handleChange} />
          </div>

          <div className="mb-3">
            <label className="form-label">Saturación de oxígeno (%)</label>
            <select name="saturacion_de_oxigeno" className="form-select" value={formulario.saturacion_de_oxigeno} onChange={handleChange}>
              <option value="">Seleccione</option>
              {[...Array(31)].map((_, i) => {
                const val = 70 + i;
                return <option key={val} value={val}>{val}%</option>;
              })}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Frecuencia cardiaca (lpm)</label>
            <select name="frecuencia_cardiaca" className="form-select" value={formulario.frecuencia_cardiaca} onChange={handleChange}>
              <option value="">Seleccione</option>
              {[...Array(151)].map((_, i) => {
                const val = 30 + i;
                return <option key={val} value={val}>{val} lpm</option>;
              })}
            </select>
          </div>

          <div className="col-md-4">
            <label className="form-label">Frecuencia respiratoria:</label>
            <input
              type="text"
              name="frecuencia_respiratoria"
              className="form-control"
              value={formulario.frecuencia_respiratoria}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Temperatura (°C)</label>
            <select name="temperatura" className="form-select" value={formulario.temperatura} onChange={handleChange}>
              <option value="">Seleccione</option>
              {[...Array(81)].map((_, i) => {
                const val = (34 + i * 0.1).toFixed(1);
                return <option key={val} value={val}>{val} °C</option>;
              })}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Índice glucémico</label>
            <select
              name="indice_glucemico"
              className="form-select"
              value={formulario.indice_glucemico}
              onChange={handleChange}
            >
              <option value="">Seleccione</option>
              <option value="no evaluado">No evaluado</option>
              {[...Array(471)].map((_, i) => {
                const val = 30 + i;
                return <option key={val} value={val}>{val}</option>;
              })}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Llenado capilar</label>
            <select name="llenado_capilar" className="form-select" value={formulario.llenado_capilar} onChange={handleChange}>
              <option value="">Seleccione</option>
              <option value="normal">Normal (&lt; 2 seg)</option>
              <option value="retrasado">Retrasado (&gt; 2 seg)</option>
              <option value="no evaluado">No evaluado</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Baño *</label>
            <select name="bano" className="form-select" value={formulario.bano} onChange={handleChange} required>
              <option value="">Seleccione</option>
              <option value="en regadera">En regadera</option>
              <option value="de esponja">De esponja</option>
              <option value="no">No</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Cambio de ropa *</label>
            <select name="cambio_ropa" className="form-select" value={formulario.cambio_ropa} onChange={handleChange} required>
              <option value="">Seleccione</option>
              <option value="total">Total</option>
              <option value="parcial">Parcial</option>
              <option value="no">No</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Curaciones (región y características)</label>
            <input type="text" name="curaciones" className="form-control" placeholder="Ej. Región lumbar, herida superficial" value={formulario.curaciones} onChange={handleChange} />
          </div>

          <div className="mb-3">
            <label className="form-label">Micciones</label>
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>#</th>
                    {["clara", "oscura", "con sedimento", "otro"].map(t => <th key={t}>{t.toUpperCase()}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {["1","2","3","4","5","6","7","no_micciono"].map(vez => (
                    <tr key={vez}>
                      <td>{vez === "no_micciono" ? "No miccionó" : `${vez}ª vez`}</td>
                      {["clara", "oscura", "con sedimento", "otro"].map(tipo => (
                        <td key={tipo}>
                          <input
                            type="checkbox"
                            checked={formulario.micciones?.[vez]?.includes(tipo) || false}
                            onChange={() => toggleMiccion(vez, tipo)}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Observaciones de micciones</label>
            <textarea
              className="form-control"
              name="micciones_observaciones"
              value={formulario.micciones_observaciones}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Evacuaciones</label>
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>#</th>
                    {["tipo1", "tipo2", "tipo3", "tipo4", "tipo5", "tipo6", "tipo7"].map(t => <th key={t}>{t.toUpperCase()}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {["1","2","3","4","5","6","7","no_evacuo"].map(vez => (
                    <tr key={vez}>
                      <td>{vez === "no_evacuo" ? "No evacuó" : `${vez}ª vez`}</td>
                      {["tipo1", "tipo2", "tipo3", "tipo4", "tipo5", "tipo6", "tipo7"].map(tipo => (
                        <td key={tipo}>
                          <input type="checkbox" checked={formulario.evacuaciones?.[vez]?.includes(tipo) || false} onChange={() => toggleEvacuacion(vez, tipo)} />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Observaciones de evacuaciones</label>
            <textarea
              className="form-control"
              name="evacuaciones_observaciones"
              value={formulario.evacuaciones_observaciones}
              onChange={handleChange}
            />
          </div>

          {["desayuno", "colacion_manana", "comida", "colacion_tarde", "cena"].map(key => (
            <div className="mb-3" key={key}>
              <label className="form-label">{key.replace("_", " ").replace(/\b\w/g, l => l.toUpperCase())}</label>
              <input type="text" className="form-control" name={key} placeholder={`Ej. ${key.replace("_", " ")}`} value={formulario[key]} onChange={handleChange} />
            </div>
          ))}

          <div className="mb-3">
            <label className="form-label">Medicamentos Extras y/o PRN</label>
            <input type="text" name="medicamentos_extras" className="form-control" placeholder="Ej. Paracetamol 500mg, PRN" value={formulario.medicamentos_extras} onChange={handleChange} />
          </div>
        </>
      )}
          <div className="mb-3">
            <label className="form-label">Observaciones generales</label>
            <textarea
              name="observaciones"
              className="form-control"
              placeholder="Ej. Se mostró tranquilo, sin quejas"
              value={formulario.observaciones}
              onChange={handleChange}
            ></textarea>
          </div>
      <button type="submit" className="btn btn-primary w-100">Enviar</button>
    </form>
  );
};

export default FormularioNuevo;